import { Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { LineItemRow } from './LineItemRow';
import type { AddOnInput } from '@everplan/shared';

type AddOnData = Omit<AddOnInput, 'sortOrder'>;

interface AddOnSectionProps {
  addOns: AddOnData[];
  onChange: (updated: AddOnData[]) => void;
}

export function AddOnSection({ addOns, onChange }: AddOnSectionProps) {
  const updateAddOn = (index: number, updated: AddOnData) => {
    const newAddOns = [...addOns];
    newAddOns[index] = updated;
    onChange(newAddOns);
  };

  const removeAddOn = (index: number) => {
    onChange(addOns.filter((_, i) => i !== index));
  };

  const addAddOn = () => {
    onChange([
      ...addOns,
      { name: '', unitCost: 0, quantity: null, section: null, description: null, notes: null },
    ]);
  };

  return (
    <div className="rounded-lg border border-border bg-card shadow-ambient">
      <div className="px-4 py-2">
        <h3 className="text-sm font-semibold">Add-Ons</h3>
      </div>

      <div className="space-y-0.5 px-4 pb-3">
        {addOns.map((addOn, i) => (
          <LineItemRow
            key={i}
            item={addOn}
            onChange={(updated) => updateAddOn(i, updated)}
            onRemove={() => removeAddOn(i)}
          />
        ))}

        <Button
          type="button"
          variant="ghost"
          size="xs"
          onClick={addAddOn}
          className="mt-0.5 text-muted-foreground"
        >
          <Plus className="size-3" />
          Add Add-On
        </Button>
      </div>
    </div>
  );
}
